import { Navigate } from 'react-router-dom';
import { useMenu } from '@/hooks/useMenu';
import Hoy from '@/pages/hoy/Hoy';
import { Spinner } from '@/components/ui/Spinner';

/**
 * LA PUERTA DE ENTRADA — depende de qué negocio sea.
 *
 * `/` era siempre `Hoy`, la pantalla del módulo `inspector`. Para los negocios
 * que lo tienen está bien: es el mandato Athena. Para los que NO lo tienen —
 * una tienda, por ejemplo — significaba aterrizar en una pantalla de un módulo
 * que no compraron: cuatro peticiones que devuelven 404 en cada carga y un
 * panel que habla de «lo que se te está escapando» a alguien que solo vende
 * ropa.
 *
 * Se vio el 25-sep-2026 abriendo el panel de Trendísima en el navegador: la
 * pantalla degrada sin romperse, pero es la casa equivocada.
 *
 * Ahora la raíz mira el MENÚ QUE SIRVE EL SERVIDOR, que es la misma fuente que
 * el sidebar y el buscador de comandos. Si el negocio tiene `/` entre sus
 * rutas, se queda en `Hoy`. Si no, entra por la primera pantalla que sí tiene.
 *
 * Lo que NO se hace: una lista de «si es tienda, anda a productos». Eso sería
 * volver a cablear el menú en el panel, que es justo lo que el registro de
 * módulos vino a eliminar.
 */
export default function Inicio() {
  const { datos, cargando, fallo, sinNegocio } = useMenu();

  // Mientras no se sabe qué tiene el negocio, no se decide: mandarlo a una
  // pantalla y rebotarlo a otra medio segundo después se ve como un error.
  if (cargando || sinNegocio) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  // Si el menú no llegó, se queda en Hoy: es el comportamiento de siempre y
  // degrada solo. Un fallo de red no debe dejar al dueño sin puerta.
  if (fallo || !datos) return <Hoy />;

  const tieneHoy = datos.rutas.some((r) => r.ruta === '/');
  if (tieneHoy) return <Hoy />;

  const primera = datos.menu.flatMap((g) => g.items)[0]?.ruta;
  return primera ? <Navigate to={primera} replace /> : <Hoy />;
}
